<template>
	<div>
	<div class="header">
		<div style="display: flex;align-items: center;">
			<img src="../../assets/images/indexIcon.png" alt="">
			<p><span>首页-资源工具池</span>-创建资源工具</p>
		</div>
		<div class="backof" @click="$router.go(-1)">返回</div>
	</div>
	<div style="display: flex;justify-content: space-between;">
		
		<div class="left">
			<div style="background:#E5EDFB;">
				<div
					style="width: 200px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;padding: 0 15px;">
					创建资源工具求助
				</div>
			</div>
			<div style="display: flex;justify-content: center;margin: 30px;">
				<div :class="['box-f',arrowStep == 1?'box-active':'']">创建资源工具求助</div>
				<div :class="['box-l',arrowStep == 3?'box-active':'']">网站审核/公布</div>
			</div>
			<div class="form-one" v-if="nowWeAre == 1">
				<div class="form-item">
				</div>
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;">*</span> 资源标题：
						</div>
						<div class="inpt">
							<el-input style="width: 100%;height: 100%;" v-model="serveData.title" type="text"
								placeholder="请输入内容" maxlength="80" show-word-limit></el-input>
						</div>
					</div>
				</div>
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;">*</span>资源分类：
						</div>
						<div style=" display: flex;">
							<div style="margin-right: 25px;">
								<el-select v-model="serveData.subjectcate_id"  placeholder="请选择学科">
									<el-option v-for="item in xueKeOptions" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div style="margin-right: 25px;">
								<el-select v-model="serveData.industry_id" placeholder="请选择行业">
									<el-option v-for="item in hangYeOptions" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div style="margin-right: 25px;">
								<el-select v-model="serveData.stage_id"  placeholder="请选择阶段">
									<el-option v-for="item in jieDuanOptions" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
				</div>
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;">*</span>添加缩略图：
						</div>
						<el-upload :on-success='uploadSLT' class="upload-demo" accept=".png,.jpeg"
							:headers='{token:$store.state.userInfo.token}' :action="uploadPath+'common/upload'" multiple
							:file-list="fileList1">
							<div
								style="width: 230px;height: 44px;border: 1px solid #D2D2D2;text-align: center;line-height: 44px;cursor: pointer; margin-right:25px;background: #f6f6f6;">
								点击上传</div>
						</el-upload>
						<div v-if="serveData.image">
							<img :src='getImgSrc(serveData.image)' alt="" style="width: 100px;height: 100px;margin-right: 25px;">
						</div>
						<!-- 	<div
							style="">
							选择系统图标</div> -->
						<el-popover placement="bottom" title="选择图标" width="510" trigger="click">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in imageList" :key="item.id"
									:class="['tubiao',item.image == serveData.image ? 'activeImg':'']"
									@click="chooseImage(item)">
									<img :src="getImgSrc(item.image)" alt="">
								</div>
							</div>
							<el-button
								style=" border-radius: 0;
								width: 230px;height: 46px;border: 1px solid #D2D2D2;text-align: center;cursor: pointer; margin-right:25px;color: black;font-size: 16px"
								slot="reference">
								选择系统图标</el-button>
						</el-popover>
						<input type="checkbox" style="color: ;background-color: #0052D9;" @change="autoImage"
							v-model="autoGetImage">自动分配
					</div>
				</div>
			
				<div class="form-item">
					<div style="display: flex;justify-content: space-between;width: 100%;">
						<div class="jtitle">
							<span style="color: red;">*</span>问题摘要描述：
						</div>
					
					</div>
					<div class="laterUp">
					</div>
					<div style="width:90%;margin-left: 140px;margin-top: 20px;">
						<div class="item-content">
							<div class="muban" @click="$router.push(`/kongEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从空白模板创建</p>
								</div>
							</div>
							<div class="muban" v-if='$store.state.releaseInfo[0].id'
								@click="$router.push(`/histroyEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从上次修改创建</p>
								</div>
							</div>
							<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
								@click="toMbDetail(item.id,0)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>{{item.name}}</p>
								</div>
							</div>
						
						</div>
					</div>
				</div>
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;">*</span>关键词：
						</div>
						<div class="inpt" style="height: 32px;">
							<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
								@close="handleClose(tag)">
								{{tag}}
							</el-tag>
							<el-input class="input-new-tag" v-if="inputVisible" id="taginp" v-model="inputValue"
								ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
								@blur="handleInputConfirm">
							</el-input>
							<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New
								Tag</el-button>
						</div>
					</div>
				</div>
				<div class="form-item">
					<div style="display: flex;justify-content: space-between;width: 100%;">
						<div class="jtitle">
							问题详情描述：
						</div>
					
					</div>
					<div class="laterUp">
					</div>
					<div style="width:90%;margin-left: 140px;margin-top: 20px;">
						<div class="item-content">
							<div class="muban" @click="$router.push(`/kongEditor?index=${1}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从空白模板创建</p>
								</div>
							</div>
							<div class="muban" v-if='$store.state.releaseInfo[1].id'
								@click="$router.push(`/histroyEditor?index=${1}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从上次修改创建</p>
								</div>
							</div>
							<div class="muban" v-for="(item,index) in slTemplate" :key="item.id"
								@click="toMbDetail(item.id,1)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>{{item.name}}</p>
								</div>
							</div>
						
						</div>
					</div>
				</div>
				<div class="form-item" style="align-items: flex-start;">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							报价展示方式：
						</div>
				
						<div></div>
					</div>
					<div>
						<el-radio-group v-model="serveData.access_right">
							<div style="margin: 30px 0;"> <el-radio :label="1">完全公开</el-radio></div>
				
							<div style="margin: 30px 0;width: 500px;"> <el-radio :label="3">对以下用户公开</el-radio>
							</div>
				
						</el-radio-group>
						
						<transferPage @removeChecked='getRemoveChecked' @leftToRight='getLeftToRight' :usersId.sync='serveData.user_ids'  pageType='edit'></transferPage>
						<div style="text-align: center">
				
						</div>
					</div>
				</div>
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;">*</span> 愿意支付积分：
						</div>
						<div class="inpt">
							<el-input style="width: 100%;height: 100%;" v-model.number="serveData.score" type="text"
								placeholder="请输愿意支付的积分" ></el-input>
						</div>
					</div>
				</div>


			</div>
			

			<div v-if="nowWeAre == 3"> <el-result icon="success" title="提交成功,等待审核..." subTitle="">
					<template slot="extra">
					</template>
				</el-result>
				<p style="margin: auto;text-align: center;cursor: pointer;" class="gocheck" @click="$router.push(`/userCenter/pthd/resourceTools`)">去个人中心查看审核状态</p>
				</div>
			<div class="nextStep" v-if="nowWeAre == 1" @click="addProjectNeed">提交</div>
		</div>
		<div class="body-right">
			<div style="background: #0052D9;"   @click="$router.push('/userCenter/drafts')">
				<img src='../../assets/images/create.png' alt="" style="width: 18px;height: 18px;"><span
					style="width:100px">从草稿中创建</span>
			</div>
			<div style="background: #18BC9C;" @click="saveCaoGao">
				<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;">
				<span style="width:100px">保存至草稿箱</span>
			</div>
		
			<div style="background:#444C69;">
				<img src='../../assets/images/yeah.png' alt="" style="width: 18px;height: 16px;"><span
					style="width:100px">完成</span>
			</div>

		</div>
	</div>
	</div>
</template>

<script>
	import isEmpty from '../../utils/isEmpty.js'
	import transferPage from '../../components/transferPage.vue'
	export default {
		name:"createTools",
		components:{
			transferPage
		},
		data(){
			return {
				type: '123',
				nowWeAre:1,
				//form1
			
				xueKeOptions: [],
				hangYeOptions: [],
				jieDuanOptions: [],
				zyTemplate: [],
				slTemplate: [],
				wzTemplate: [],
				imageList:[],
				value: '',
				fileList1: [],
				autoGetImage: false,
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				arrowStep:1,
				radio: 3,
				fileList2: [],

				title: '',
			
				serveData:{}
			}
		},
		async created() {
			await this.getDraftsDetail()
			this.getXueKeList()
			this.getTemplateLists()
			this.getImageList()
			const release = [{
					id: this.serveData.summary,
					first_id: '',
				},
				{
					id: this.serveData.content,
					first_id: '',
				},
			]
			this.$store.commit('init_releaseInfo', release)
		},
		watch: {
			'$store.state.releaseInfo': {
				handler(n, o) {
					this.serveData.summary = this.$store.state.releaseInfo[0].id
					this.serveData.content = this.$store.state.releaseInfo[1].id
				},
				deep: true,
				immediate: true
			},
		
		},
		methods: {
			async getDraftsDetail(){
				const detail = await this.$api.getMyToosDraftsDetail({id:this.$route.query.id})
				this.serveData = detail.data
				this.serveData.validity_type = detail.data.validity_type *1
				if( this.serveData.tags != ''){
					this.dynamicTags = this.serveData.tags.split(',')
				}
			},
			async saveCaoGao(){
				this.serveData.draft = 1
				const project = await this.$api.addReosureceToolSeekHelp({
					...this.serveData
				})
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}
			},
		
			async addProjectNeed() {
				//
				if(this.verificationPwd()){
					this.serveData.draft = 0
				const project = await this.$api.addReosureceToolSeekHelp({
					...this.serveData
				})
				console.log(project);
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					this.nowWeAre = 3
					this.arrowStep = 3
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}	
				}
				
			},
			getRemoveChecked(e) {
				let ids = e.join(',')
				this.serveData.user_ids = ids 
			},
			getLeftToRight(e) {
				let ids = e.join(',')
				this.serveData.user_ids = ids 
			},
			async getXueKeList() {
				const list = await this.$api.getLeftSubjectcateLists()
				this.xueKeOptions = list.data
				const hy = await this.$api.getHangYeLists()
				this.hangYeOptions = hy.data
				const jieDuan = await this.$api.getJieDuanLists()
				this.jieDuanOptions = jieDuan.data
			},
			async getTemplateLists() {
				const zy = await this.$api.templateLists({
					templatecate_id: 7
				})
				this.zyTemplate = zy.data
				console.log(this.zyTemplate);
				const sl = await this.$api.templateLists({
					templatecate_id: 8
				})
				this.slTemplate = sl.data
			},
			async getImageList() {
				const image = await this.$api.imageLists()
				this.imageList = image.data
				console.log(image.data);
			},
			autoImage(e) {
				if (this.autoGetImage) {
					const randomIndex = Math.floor(Math.random() * this.imageList.length);
					this.serveData.image = this.imageList[randomIndex].image
				}
			},
			chooseImage(item) {
				this.serveData.image = item.image
			},
			uploadSLT(e, a) {
				console.log(e.data.url);
				this.serveData.image = e.data.url
			},
			toMbDetail(id, index) {
				this.$router.push(`/editor?id=${id}&index=${index}`)
			},
			verificationPwd() {
				if (this.serveData.summary === "" || this.serveData.title === "" || this.serveData.subjectcate_id === "" || this.serveData.score  === "" ||
					this.serveData.industry_id === "" || this.serveData.stage_id === "" || this.serveData.image === "" || this.serveData.tags === "") {
					this.$message.error('请将带*信息填写完整');
					return false;
				}
				if (this.serveData.project_need_files != [] & this.serveData.password) {
					this.$message.error('请设置文件加密密码');
					return false;
				}
				return true
			},
			//addTag
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
					this.serveData.tags = this.dynamicTags.join(',');
				}
				this.inputVisible = false;
				this.inputValue = '';
			}
		}
	}
</script>
<style>
	/* .el-radio__label {
		color: black;
	}

	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}

	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}

	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}

	.el-radio__inner {
		border-radius: 0;
	}

	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	}
 */
	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	#taginp {
		height: 32px;
	}
	
</style>
<style scoped lang="less">
	.tubiao {
		width: 100px;
		height: 100px;
		cursor: pointer;
	
		&>img {
			width: 100%;
			height: 100%;
		}
	
		&:hover {
			border: 1px solid #eee;
			padding: 3px;
			box-sizing: border-box;
			margin: 0 3px;
		}
	}
	.activeImg {
		border: 1px solid #0052D9;
		padding: 3px;
		box-sizing: border-box;
		margin: 0 3px;
	}
	
	.gocheck{
		&:hover{
			color: #0052D9;
		}
	}
	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}
	
		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;
	
		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}
	
			&>p {
				font-size: 16px;
				margin-left: 10px;
	
				&>span {
					color: #888888;
				}
			}
		}
	}
	.captcha-row {
		display: flex;

		.captcha-button {
			background: #048fff;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 4rpx 8rpx;
			width: 320rpx;
			border-radius: 4rpx;
		}
	}

	.getCode {
		width: 133px;
		height: 40px;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	/deep/.el-input__inner {
		height: 46px;
		border: 1px solid #D2D2D2;
	}

	.nextStep {
		width: 261px;
		height: 40px;
		margin: 0 auto;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		color: white;
		font-size: 18px;
		background: #0052D9;
	}

	.form-one {

		padding: 20px;
		padding-right: 40px;
		box-sizing: border-box;

		.form-item {
			.bottom {
				margin-top: 30px;
			}

			.inpt {
				width: 855px;
				height: 46px;
			}

			input[type=checkbox] {
				cursor: pointer;
				position: relative;
				width: 18px;
				height: 18px;
				font-size: 12px;
			}

			input[type=checkbox]::after {
				position: absolute;
				top: 0;
				color: #000;
				width: 18px;
				height: 16px;
				display: inline-block;
				visibility: visible;
				padding-left: 0px;
				text-align: center;
				content: ' ';
				border-radius: 3px
			}

			input[type=checkbox]:checked::after {
				content: "✓";
				color: #fff;
				font-size: 12px;
				font-weight: bold;
				background-color: #0052D9;
			}

			.jtitle {
				width: 155px;
			}

			.item-content {
				flex: 1;
				display: flex;
				overflow-x: auto;
				white-space: nowrap;
			
				.muban {
					margin-left: 50px;
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 148px;
					height: 148px;
					background: #F6F6F6;
					cursor: pointer;
			
					&>div {
						display: flex;
						justify-content: center;
						flex-wrap: wrap;
					}
			
					p {
						width: 100%;
						text-align: center;
						margin-top: 10px;
					}
			
					&:first-child {
						margin-left: 0;
					}
			
				}
			
				.muban:hover {
					background: #e3e3e3;
				}
			}

			display: flex;
			flex-wrap: wrap;
			width: 100%;
			margin: 20px 0 40px 0;
		}

		.laterUp {
			display: flex;
			align-items: center;


		}
	}

	.box,
	.box-f,
	.box-l {
		position: relative;
		/* 设置元素定位的基准 */
		width: 270px;
		height: 48px;
		background-color: #F6F6F6;
		margin-left: 24px;
		text-align: center;
		line-height: 48px;
		font-size: 18px;
	}

	/* 设置前面板（上半部分） */
	.box::before,
	.box-f::before {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		right: 0;
		transform: translateX(100%) rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent #F6F6F6 transparent;
	}

	.box::after,
	.box-l::after {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		left: 0;
		transform: rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent white transparent;
	}

	.box-active,
	{
	background: #0052D9;
	color: white;
	}

	.box-active::before {
		border-color: transparent transparent #0052D9 transparent;
	}

	/* 设置后面板（下半部分） */

	.left {
		padding: 25px 0;
		box-sizing: border-box;
		width: 1180px;
		margin-bottom: 50px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}
</style>